import SEO from "./SEO";
import StructuredData from "./StructuredData";
import HeroSection from "./HeroSection";
import ExperienceSection from "./ExperienceSection";
import ProjectsSection from "./ProjectsSection";
import HackathonsSection from "./HackathonsSection";
import OpenSourceSection from "./OpenSourceSection";

const HomePage = () => {
  const personSchema = {
    "@context": "https://schema.org",
    "@type": "Person",
    name: "Jan Kwiatkowski",
    jobTitle: "Blockchain Engineer",
    url: "https://spaceh3ad.com",
    sameAs: [
      "https://github.com/spaceh3ad",
      "https://twitter.com/hussar_eth",
      "https://linkedin.com/in/jan-kwiatkowski-web3",
    ],
    knowsAbout: [
      "Blockchain Development",
      "Smart Contracts",
      "Solidity",
      "Ethereum",
      "Web3",
      "DeFi",
    ],
  };

  return (
    <>
      <SEO
        title="Jan Kwiatkowski - Blockchain Developer"
        description="Blockchain developer with experience in smart contracts, DeFi, and Web3. View my work experience, hackathon projects, and open source contributions."
        keywords="blockchain developer, smart contracts, Web3, DeFi, Ethereum, Solidity"
        url="https://spaceh3ad.com/"
        type="website"
      />
      <StructuredData data={personSchema} />
      <HeroSection />
      <ExperienceSection />
      <ProjectsSection />
      <HackathonsSection />
      <OpenSourceSection />
    </>
  );
};

export default HomePage;
